// @flow

export const PLUGIN_NAME = 'trix-web-plugin-clm-contract';
